export enum ReportStatus {
    DRAFT = 'DRAFT',
    NOT_VERIFIED = 'NOT_VERIFIED',
    OPEN = 'OPEN',
    OFFLINE_DRAFT = 'OFFLINE_DRAFT',
    OFFLINE_READY_TO_SYNC = 'OFFLINE_READY_TO_SYNC',
    OFFLINE_SYNC_ERROR = 'OFFLINE_SYNC_ERROR'
}
